<div class="wagon-header">
    <p>{{ wagonData.name }}</p>
    <mat-icon (click)="edit()" title="Edit">edit</mat-icon>
</div>
<div class="wagon-content">
    <div *ngIf="imageSrc; else deleteVariant">
        <img *ngIf="wagonData.variantId !== null" [ngClass]="wagonData.rotated ? 'imageRotated' : 'image'" title="image of {{ wagonData.name }}"
            [src]="imageSrc" />
        <img *ngIf="wagonData.variantId === null" class="locomotive-image" title="image of {{ wagonData.name }}"
            [src]="imageSrc" />
    </div>
    <ng-template #deleteVariant>
        <img class="warningImage" title="This variant was deleted!" [src]="imageSrc" />
    </ng-template>
    <mat-icon *ngIf="!isLastWagon" (click)="swapPlaces()" title="swap places">loop</mat-icon>
    <mat-icon (click)="add()" title="Add Variant">add_circle_outline</mat-icon>
</div>
<div class="wagon-actions">
    <mat-icon (click)="delete()" title="Remove {{ wagonData.name }} From Train">delete</mat-icon>
    <mat-icon *ngIf="wagonData.variantId" (click)="rotate()" title="Rotate {{ wagonData.name }}">rotate_left</mat-icon>
</div>